import React from 'react'
import { Link} from 'gatsby'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import './ContentPageStyles.css'

const FeaturedItemCard = ({ featuredItem }) => {
    return (
        <Col md={6} lg={4} className="my-2">
            <Card className="card border-top-accent-cool h-100 featured-item">
                <Card.Body>
                    <h3 className="h5 card-title">{featuredItem.data.title}</h3>
                    <p className="card-text">{featuredItem.data.featured_blurb}</p>
                </Card.Body>
                <Card.Footer>
                    <span className="float-left">
                    </span>
                    <span className="float-right">
                        <Link className="stretched-link" to={ featuredItem.url }>  
                        View content <FontAwesomeIcon icon={faAngleDoubleRight} className="ml-2"/>
                        </Link>
                    </span>
                </Card.Footer>
            </Card>
        </Col>
    )
 }

export default FeaturedItemCard;